/**
 * @file   src\Pages\RevenueReports.tsx
 * @brief  Revenue Reports page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Container, Table, useEffect, useOutletContext, useState, Button, useNavigate, useParams, Modal } from '../utils/thirdpartyComponents';
import CWSelect from '../components/CWSelect';
import { userType } from '../utils/enums';
import { AppContextType } from '../interfaces/generalInterface';
import { pageURLs } from '../utils/pageUrls';
import AddIcon from '../assets/images/icons/addicon';
import EditIcon from '../assets/images/icons/editicon';
import DeleteIcon from '../assets/images/icons/deleteicon';
import axios from '../config/axiosConfig';
import { MessageToaster } from "../utils/toastUtil";
import { CompanyApi, LocationApi, LocationManagerApi } from '../utils/apiUrls';
import { LocationItem, Option, CarWashLocationManagers } from '../interfaces/LocationManagerInterface';
import SmallLoader from '../components/SmallLoader';


const LocationManagers = (props: any) => {
  const carwash_owner = (props.userType === userType['CARWASH-OWNER']) ? true : false
  const params = useParams();
  const toaster = new MessageToaster();
  const [loading, setLoading] = useState(true);
  const [currentPage] = useState(1);
  // State to handle selected location form dropdown
  const [selectedLocation, setSelectedLocation] = useState(0);

  // Access the context
  const navigate = useNavigate()
  const { updateData } = useOutletContext<AppContextType>();

  // State to handle locations given in dropdown
  const [locations, setLocations] = useState<Option[]>([]);

  useEffect(() => {
    getCompany();
    getLocationmanagers(1);
  }, [])

  // Function to fetch company information
  const getCompany = async () => {
    try {
      const param1 = `${params.id}`;
      const { data } = (carwash_owner) ? await axios.get(CompanyApi.CARWASH_OWNER_COMPANY_DETAILS) : await axios.get(CompanyApi.GET_COMPANY + param1);

      // To get locations under company
      await getCompanyLocations(data.data.carWashGUID)
    } catch (error: any) {
      console.error('Error fetching company information:', error.message);
      throw new Error(error.response?.data?.message || error.message);
    }
  };

  const getCompanyLocations = async (carwashGuid: string) => {
    try {

      const { data } = (carwash_owner) ? await axios.get(LocationApi.CARWASH_OWNER_GET_COMPANY_LOCATIONS) : await axios.get(LocationApi.GET_COMPANY_LOCATIONS + carwashGuid);
      if (data.error === 0) {
        const location_list: LocationItem[] = data?.data

        // Transform the array
        const transformedArray: Option[] = location_list.map(item => ({
          label: item.locationName,
          value: item.locationId,
        }));

        setLocations(transformedArray)
      }
      else {
        // show error message
        toaster.toastError(data.message);
      }
    } catch (error: any) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }

  const handleSelectChange = (selectedOption: any) => {
    // Update selected location
    setSelectedLocation(selectedOption.value);
    console.log(selectedOption.value)
  };

  const [showUserDeletepoup, setShowUserDeletepoup] = useState<boolean>(false);
  useEffect(() => {
    getLocationmanagers(currentPage);  // Fetch and update the subscription list
  }, [currentPage, selectedLocation, showUserDeletepoup]);

  // State to handle listed locationmanagers
  const [locationmanagers, setLocationmanagers] = useState<CarWashLocationManagers[]>([]);

  const getLocationmanagers = async (pageNo = 1) => {
    try {
      let param;
      if (selectedLocation !== 0) {
        if (carwash_owner) {
          param = `?locationId=${selectedLocation}&pageNo=${pageNo}&sortOrder=1&sortField=1`;
        } else {
          param = `?locationId=${selectedLocation}&pageNo=${pageNo}&sortOrder=1&sortField=1`;
        }
      } else {
        if (carwash_owner) {
          param = `?pageNo=${pageNo}&sortOrder=1&sortField=1`;
        } else {
          param = `?pageNo=${pageNo}&sortOrder=1&sortField=1`;
        }
      }

      const { data } = (carwash_owner) ? await axios.get(LocationManagerApi.CARWASH_OWNER_LIST_LOCATIONMANAGER + param) : await axios.get(LocationManagerApi.CARWASH_OWNER_LIST_LOCATIONMANAGER + param);
      if (data?.error === 0 && Array.isArray(data?.data?.list)) {
        const locationmanagerslist: CarWashLocationManagers[] = data.data.list;
        // Check if location_list is empty
        if (locationmanagerslist.length > 0) {
          setLocationmanagers(locationmanagerslist)
        } else {
          console.log('Location Managers list is empty');
          setLocationmanagers([]);  // Set to an empty array if locationmanagerslist is empty
        }
      } else {
        console.log('Location Managers list is not available or is not an array');
        setLocationmanagers([]);  // Set to an empty array if data is not available
      }
      setLoading(false)
    } catch (error: any) {
      console.error('Error fetching company list:', error.message);
      setLoading(false)
      throw new Error(error.response?.data?.message || error.message);
    }
  }

  // To display heading
  useEffect(() => {
    handleUpdate()
  }, [])

  // Update the data
  const handleUpdate = () => {
    updateData({ heading: `Location Managers`, url: pageURLs.location_managers, showBackButton: false, showMainMenu: true, activeLink: "" });
  };

  const addNewUser = () => {
    navigate("/" + pageURLs.add_cwo_user)
  }

  const [selected_user_for_delete, setSelected_user_for_delete] = useState(0);
  const [selected_user_name_for_delete, setSelected_user_name_for_delete] = useState('');
  const DeletebuttonClick = (delete_user_id: number, delete_user_name: string) => {
    setSelected_user_for_delete(delete_user_id);
    setSelected_user_name_for_delete(delete_user_name);
    setShowUserDeletepoup(true);
  }


  //Hide ppopup
  const hideshowUserDeleteModal = () => {
    setShowUserDeletepoup(false);
  }

  const Ondeleteuser = async () => {
    try {
      setLoading(true); // Show loader
      const deleteUserRequest = {
        userId: selected_user_for_delete,
      };
      const responseUserDelete = (!carwash_owner) ?
        await axios.post(LocationManagerApi.CARWASH_OWNER_DELETE_LOCATIONMANAGER, deleteUserRequest)
        : await axios.post(LocationManagerApi.CARWASH_OWNER_DELETE_LOCATIONMANAGER, deleteUserRequest)
      if (responseUserDelete?.data?.error === 0) {
        // window.location.reload();
        setShowUserDeletepoup(false);
      }
      else {
        toaster.toastError(responseUserDelete?.data?.message);
        setShowUserDeletepoup(false);
      }

    } catch (error: any) {
      toaster.toastError(error.response?.data?.message || error.message);
    } finally {
      setLoading(false); // Hide loader
    }
  }


  return (

    <div className='manage-carwash-container order-list-container'>
      <Container>
        <div className="manage-header-block d-flex justify-content-between align-items-center">
          <Button
            title="Add New User"
            type="submit"
            variant="primary"
            className="primary-btn ms-auto d-flex align-items-center"
            onClick={() => addNewUser()}
          >
            {"Add New User"}
            <AddIcon />
          </Button>
        </div>
        <div className="manage-header-block d-flex justify-content-between align-items-center">
          <div className="search-wrap w-100">
            <div className="result-group d-flex align-items-center">
              <p className='f-bold'>Select Location</p>
              <CWSelect
                id="result"
                name="result"
                options={locations}
                dropdownGap={0}
                dropdownPosition="auto"
                placeholder="Select Location"
                onChange={(selectedOptions) => handleSelectChange(selectedOptions[0])}
                multi={false}
              />
            </div>
          </div>
        </div>
        <div className="cw-table-wrap">
          <Table responsive className='m-0'>
            <thead>
              <tr>
                <th>Car Wash Location</th>
                <th>Name</th>
                <th>Email</th>
                <th>Permission Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {locationmanagers.map((carWash, index) => (
                <tr key={index}>
                  <td>{carWash.LocationName}</td>
                  <td>{carWash.FullName}</td>
                  <td>{carWash.Email}</td>
                  <td>{carWash.PermissionType}</td>
                  <td className='nowrap'>
                    <div className="active-group d-flex align-items-center">
                      <Button variant="light" className="light-btn action-btn" title="Edit" onClick={() => navigate("/" + pageURLs.edit_cwo_user + "/" + carWash.UserID)}><EditIcon /></Button>
                      <Button variant="light" className="light-btn action-btn" title="Delete" onClick={() => DeletebuttonClick(carWash.UserID, carWash.FullName)}><DeleteIcon /></Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container >
      <Modal
        show={showUserDeletepoup}
        onHide={hideshowUserDeleteModal}
        centered
        className='add-modal'
      >
        <Modal.Body className='text-center'>
          <h5 className='f-bold text-center'>Do you want to delete the Bay  {selected_user_name_for_delete}?</h5>
          <div className="btn-sec d-grid">
            <Button variant="light" className="secondary-btn" onClick={hideshowUserDeleteModal}>Not Now</Button>
            <Button variant="primary" className='primary-btn btn-main m-0' onClick={Ondeleteuser}>Yes</Button>
          </div>
        </Modal.Body>
      </Modal>
      {loading && <SmallLoader />}
    </div >
  )
}

export default LocationManagers;
